/// <reference path="skyward.ui.window.js" />

(function (skyward, $, undefined)
{
    "use strict";
    skyward.window.registerLoadDOMCallback(initCheckboxMassSelectButtons);

    function initCheckboxMassSelectButtons(selector)
    {
        var jqSelector = $(selector);
        jqSelector.find(".checkbox-mass-select-button").each(function ()
        {
            var button = $(this);

            var callback;
            if (typeof this.onclick === 'function')
            {
                callback = this.onclick;
            }
            else
            {
                calback = function () { };
            }
            this.onclick = undefined;

            var relatedCheckboxSelector = button.data("relatedCheckboxSelector");
            var data = {jqSelector: jqSelector, button: button, relatedCheckboxSelector: relatedCheckboxSelector, callback : callback };
            jqSelector.on("change jschange", relatedCheckboxSelector, data, updateMassSelectButton);
            button.on('click', null, data, massSelectButtonClicked).on("selectedRecordCountChanged", null, data, updateMassSelectButton);

            updateMassSelectButton({ data: data });
        });
    }

    function updateMassSelectButton(event)
    {
        if($(this).is("massChanging").length)
        {
            return;
        }

        var button = event.data.button;
        var totalRecordCount = button.data("totalRecordCount");
        var selectedRecordCount = button.data("selectedRecordCount");
        
        if (totalRecordCount == selectedRecordCount && selectedRecordCount > 0)
        {
            button.addClass("allChecked").removeClass("noneChecked").removeClass("someChecked");
        }
        else if (selectedRecordCount > 0)
        {
            button.addClass("someChecked").removeClass("allChecked").removeClass("noneChecked");
        }
        else
        {
            button.addClass("noneChecked").removeClass("allChecked").removeClass("someChecked");
        }
    }

    function massSelectButtonClicked(event)
    {
        var button = $(this);
        var callbackResult;
        if (typeof event.data.callback === 'function')
        {
            callbackResult = event.data.callback.apply(this,arguments);
        }

        // Wait for callbacks with async calls to resolve before checking boxes.
        $.when(callbackResult).then(function ()
        {
            var allRelatedCheckboxes = event.data.jqSelector.find(event.data.relatedCheckboxSelector);
            if (!button.hasClass("noneChecked"))
            {
                allRelatedCheckboxes.prop("checked", false);
            }
            else
            {
                allRelatedCheckboxes.prop("checked", true);
            }
        });

        updateMassSelectButton({ data: event.data });
        return false;
    }

}(window.skyward = window.skyward || {}, window.jQuery));
